import { render, staticRenderFns } from "./SortFilterTable.vue?vue&type=template&id=07e55954&scoped=true"
import script from "./SortFilterTable.vue?vue&type=script&lang=js"
export * from "./SortFilterTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e55954",
  null
  
)

export default component.exports